module.exports = __webpack_public_path__ + "static/media/yourturn.de3b9770.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/yourturn.mp3
// module id = 745
// module chunks = 0